import { Actions as ControlActions, Type as ControlType } from '../Controls';
import { CommentContext } from 'models/CommentHistory';

export interface State {
  isLoading: boolean;
  data: CommentContext[];
  filteredCommentCount: number;
}

export const initialState: State = {
  isLoading: true,
  data: [],
  filteredCommentCount: 0,
};

export enum Type {
  SET_RESULT = 'COMMENTS/COMMENT_CONTEXTS/SET_RESULT',
}

interface Action<T> {
  type: T;
}

export interface SetResult extends Action<Type.SET_RESULT> {
  data: CommentContext[];
  filteredCommentCount: number;
}

type Actions = ControlActions | SetResult;

export default (state = initialState, action: Actions): State => {
  switch (action.type) {
    case ControlType.SET_ORGANIZATION_UUID:
    case ControlType.SET_DATE_RANGE:
    case ControlType.SET_COMMENT_TYPE:
    case ControlType.SET_SEVERITY:
    case ControlType.SET_CATEGORY:
    case ControlType.SET_AUTHOR:
    case ControlType.SET_REPO_UUID:
    case ControlType.RESET_FILTERS:
    case ControlType.SET_SORT_BY:
    case ControlType.SET_PAGE:
      return {
        ...state,
        isLoading: true,
        data: [],
        filteredCommentCount: 0,
      };
    case Type.SET_RESULT:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        filteredCommentCount: action.filteredCommentCount,
      };
    default:
      return state;
  }
};

export const actions = {
  setCommentContextResult: (
    data: CommentContext[],
    filteredCommentCount: number
  ): SetResult => ({
    type: Type.SET_RESULT,
    data,
    filteredCommentCount,
  }),
};
